import { createSlice } from '@reduxjs/toolkit';
import { productGalleryTitleManage } from './productGalleryTitleAsyncThunk';

const productGalleryTitleManageSlice = createSlice({
  name: "productGalleryTitle",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productGalleryTitleManage.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productGalleryTitleManage.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productGalleryTitleManage.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productGalleryTitleManageSlice.reducer;